import { ChangeDetectorRef, Component, DestroyRef, inject, Inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgForm } from '@angular/forms';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { faCheck, faPlusCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import { forkJoin } from 'rxjs';
import { ErrorService } from '../../../../../@core/utils/error.service';
import { Room } from '../../../models/storage/room';
import { RoomLocation } from '../../../models/storage/room-location';
import { Warehouse } from '../../../models/storage/warehouse';
import { RoomService } from '../../../services/storage/room-service';
import { WarehouseService } from '../../../services/storage/warehouse-service';
import { KwFilterDropdownService } from '../../../widgets/kw-filter-dropdown/kw-filter-dropdown.service';

@Component({
  selector: 'room-location-edit',
  templateUrl: './room-location-edit.component.html',
  styleUrls: ['./room-location-edit.component.scss']
})
export class RoomLocationEditComponent implements OnInit {
  private destroyRef = inject(DestroyRef);

  public faPlusCircle = faPlusCircle;

  public editRoomLocation: RoomLocation = {};
  public roomLocationId: number;
  public roomLocationLoading = true;
  public submitting: any;
  public warehouses: Warehouse[] = [];
  public rooms: Room[] = [];
  public allRooms: Room[] = [];
  public warehouseId: number;
  public room: Room = {};
  // public editWarehouse: Warehouse;

  public faTimes = faTimes;
  public faCheck = faCheck;

  constructor(
    private errorService: ErrorService,
    private roomLocationService: RoomService,
    public service: RoomService,
    private _bottomSheetRef: MatBottomSheetRef<RoomLocationEditComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data,
    private changeDetRef: ChangeDetectorRef,
    public warehouseService: WarehouseService,
    private filterService: KwFilterDropdownService) {
    // if (data.roomLocation)
    //   this.editRoomLocation = data.roomLocation;
  }

  ngOnInit() {
    this.roomLocationLoading = true;
    if (this.data?.roomLocation) {
      this.roomLocationService.getRoomLocation(this.data.roomLocation.id).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:roomLocation => {
        this.editRoomLocation = roomLocation;

        forkJoin([
          this.warehouseService.getWarehouses(),
          this.service.getRooms(),
        ]).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:data => {
          this.warehouses = data[0];
          this.rooms = data[1];
          this.allRooms = data[1];

          this.room = this.rooms.find(x => x.id == this.editRoomLocation.roomId);
          this.warehouseId = this.room.warehouseId;
          this.roomLocationLoading = false;
          this.changeDetRef.detectChanges();
        },error: err => {
          this.errorService.handleError(err);
          this.roomLocationLoading = false;
          this.changeDetRef.detectChanges();
        }});
      }, error:err => {
        this.roomLocationLoading = false;
        this.errorService.handleError(err);
        this.changeDetRef.detectChanges();
      }});
    }
    else {
      this.editRoomLocation = {};
      this.editRoomLocation.isActive = true;

      forkJoin([
        this.warehouseService.getWarehouses(),
        this.service.getRooms(),
      ]).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:data => {
        this.warehouses = data[0];
        this.rooms = data[1];
        this.allRooms = data[1];

        this.roomLocationLoading = false;
        this.changeDetRef.detectChanges();
      }, error:err => {
        this.errorService.handleError(err);
        this.roomLocationLoading = false;

        this.changeDetRef.detectChanges();
      }});
    }
  }


  deleteRoomLocationClicked(form: NgForm) {
    this.roomLocationLoading = true;
    if (this.editRoomLocation.id !== null && this.editRoomLocation.id !== undefined) {
      this.service.deleteRoomLocation(this.editRoomLocation.id).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:x => {
        // Keep the filter dropdown cache in sync so other pages drop the deleted location immediately
        this.filterService.removeCached('roomLocation', this.editRoomLocation.id);
        this.editRoomLocation = {};
        this.roomLocationLoading = false;
        form.resetForm();
        this._bottomSheetRef.dismiss();
      },error: err => { this.errorService.handleError(err); this.roomLocationLoading = false; form.resetForm(); }});
    }
    else {
      alert("No Room Location Selected!!");
      this.roomLocationLoading = false;
      form.resetForm();
    }
  }


  saveRoomLocationClicked(form: NgForm) {
    this.roomLocationLoading = true;
    if (this.editRoomLocation.isActive === null || this.editRoomLocation.isActive === undefined) { this.editRoomLocation.isActive = false; };
    if (this.editRoomLocation.id !== null && this.editRoomLocation.id !== undefined) {
      this.editRoomLocation.updatedDate = new Date;
      this.service.putRoomLocation(this.editRoomLocation).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:x => {
        this.filterService.upsertCached('roomLocation', this.editRoomLocation);
        this.editRoomLocation = {};
        this.roomLocationLoading = false;
        form.resetForm();
        this._bottomSheetRef.dismiss();
      },error: err => { this.errorService.handleError(err); this.roomLocationLoading = false; form.resetForm(); }});
    }
    else {
      this.editRoomLocation.id = 0;
      this.editRoomLocation.createdDate = new Date();
      this.editRoomLocation.updatedDate = this.editRoomLocation.createdDate;
      this.service.postRoomLocation(this.editRoomLocation).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:x => {
        // this.editRoomLocation.warehouse = this.editWarehouse;
        this.filterService.upsertCached('roomLocation', x);
        this.editRoomLocation = {};
        this.roomLocationLoading = false;
        form.resetForm();
        this._bottomSheetRef.dismiss();
      }, error:err => { this.errorService.handleError(err); this.roomLocationLoading = false; form.resetForm(); }});
    }
  }

  cancelClicked(form: NgForm) {
    this.editRoomLocation = {};
    this._bottomSheetRef.dismiss();
  }

  roomChanged(id: number) {
    let editRoom = this.rooms.find(x => x.id == id);
    this.editRoomLocation.roomId = editRoom.id;

    this.warehouseId = editRoom.warehouseId;
  }

  warehouseChanged(id: number) {
    let editWarehouse = this.warehouses.find(x => x.id === id);
    this.rooms = [...this.allRooms.filter(x => x.warehouseId == editWarehouse.id)];
    this.changeDetRef.detectChanges();
  }

}
